import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { stylingHelpers } from '../../designTokens';

import RadioItem from './RadioItem';

const { flexStack, resetList } = stylingHelpers;

const baseStyles = () => css`
  ${flexStack()}
  ${resetList()}
`;

const Container = styled('ul')(baseStyles);

const RadioList = ({ items, ...rest }) => (
  <Container>
    {items.map(({ id, ...props }) => (
      <RadioItem key={id} itemId={id} {...props} {...rest} />
    ))}
  </Container>
);

RadioList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      text: PropTypes.string,
    }),
  ),
};

RadioList.defaultProps = {
  items: [
    {
      id: 1,
      title: 'This is a title text.',
      text: 'This is a body text.',
    },
    {
      id: 2,
      title: 'This is a title text.',
      text: 'This is a body text.',
    },
  ],
};

export default RadioList;
